import { render, staticRenderFns } from "./ClinicUsers.vue?vue&type=template&id=61171aa5&"
import script from "./ClinicUsers.vue?vue&type=script&lang=js&"
export * from "./ClinicUsers.vue?vue&type=script&lang=js&"
import style0 from "./ClinicUsers.vue?vue&type=style&index=0&id=61171aa5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports